/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiProjectprioritiesIdMutationRequest,
  PutApiProjectprioritiesIdMutationResponse,
  PutApiProjectprioritiesIdPathParams,
} from '../models/PutApiProjectprioritiesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiProjectprioritiesIdMutationResponseSchema,
  putApiProjectprioritiesIdMutationRequestSchema,
} from '../zod/putApiProjectprioritiesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiProjectprioritiesIdMutationKey = () =>
  [{ url: '/api/projectpriorities/:id' }] as const;

export type PutApiProjectprioritiesIdMutationKey = ReturnType<
  typeof putApiProjectprioritiesIdMutationKey
>;

/**
 * {@link /api/projectpriorities/:id}
 */
export async function putApiProjectprioritiesId(
  id: PutApiProjectprioritiesIdPathParams['id'],
  data: PutApiProjectprioritiesIdMutationRequest,
  config: Partial<RequestConfig<PutApiProjectprioritiesIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData =
    putApiProjectprioritiesIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiProjectprioritiesIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiProjectprioritiesIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/projectpriorities/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiProjectprioritiesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectpriorities/:id}
 */
export function usePutApiProjectprioritiesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiProjectprioritiesIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiProjectprioritiesIdPathParams['id'];
        data: PutApiProjectprioritiesIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiProjectprioritiesIdMutationRequest>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiProjectprioritiesIdMutationKey();

  return useMutation<
    PutApiProjectprioritiesIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiProjectprioritiesIdPathParams['id'];
      data: PutApiProjectprioritiesIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiProjectprioritiesId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
